/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateProjectProgressCommand } from '../../models/update-project-progress-command';
import { UpdateProjectProgressCommandResult } from '../../models/update-project-progress-command-result';

export interface ApiProjectProgressUpdateProgressPost$Plain$Params {
      body?: UpdateProjectProgressCommand
}

export function apiProjectProgressUpdateProgressPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectProgressUpdateProgressPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateProjectProgressCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectProgressUpdateProgressPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateProjectProgressCommandResult>;
    })
  );
}

apiProjectProgressUpdateProgressPost$Plain.PATH = '/api/ProjectProgress/UpdateProgress';
